import React, { useState, useEffect } from "react"
import assetsSummaryJson from "../../src/json-data/assetssummarydata.json";
import Offcanvas from 'react-bootstrap/Offcanvas';
import Modal from 'react-bootstrap/Modal';
import { Container, lightColors, Button, darkColors, Link } from 'react-floating-action-button';
import DgGeneralInfoTable from "./dg-general-info-table";
import { configData } from "../config/systemconfigurationconstants";
import UseLambdaInvocations from '../hooks/useLambdaInvocations';
import lambdaConfig from '../hooks/lambdaConfig';
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import DgGeneralInfoSave from "./dg-general-info-save";
import DgGeneralInfoPublishCompleteLoan from "./dg-general-info-publishcomplete";
const GeneralInformationAssetsTab = ({ LoanStatus, GlassBoxDatas, getGeneralInfoDetailsForLoan, conditionjson, setConditionJson }) => {
    const { invokeLambda, loading, error } = UseLambdaInvocations();
    const navigate = useNavigate();

    // useEffect(() => {
    //     console.log(GlassBoxDatas?.ConditionDetails, "GlassBoxDatas")
    // }, [])
    const [userRights] = useState(JSON.parse(localStorage.getItem("UserRights")));
    const [rolesAndRights] = useState(JSON.parse(localStorage.getItem("RolesAndRights")));
    const [showAssetsSummary, setShowAssetsSummary] = useState(false);
    const [showAssetsCondition, setShowAssetsCondition] = useState(false);
    const goToAssetsCondition = () => setShowAssetsCondition(true);
    const closeAssetsCondition = () => setShowAssetsCondition(false);
    const goToAssetsSummary = () => setShowAssetsSummary(true);
    const closeAssetsSummary = () => setShowAssetsSummary(false);
    const [userAddedComments, setUserAddedComments] = useState('')
    const [isCheckedFilter, setIsCheckedFilter] = useState(true);
    const [assetsGridData, setAssetsGridData] = useState(GlassBoxDatas?.ConditionDetails[0])
    useEffect(() => {
        const shouldNegateReviewed = GlassBoxDatas?.ConditionDetails[0]?.Verbiage?.some(item => item.RRSV === "Reviewed");
        // Create a new object with filtered Verbiage
        const result = {
            ...GlassBoxDatas?.ConditionDetails[0],
            Verbiage: shouldNegateReviewed
                ? GlassBoxDatas?.ConditionDetails[0]?.Verbiage?.filter(item => item.RRSV !== "Reviewed")
                : GlassBoxDatas?.ConditionDetails[0]?.Verbiage
        };
        console.log(result)
        setAssetsGridData(result);
    }, [])
    const addAssestsCondition = async () => {
        let conditionjsonForAdd = {
            "LoanGuid": localStorage.getItem("loanGuid"),
            "Action": "Add",
            "Details": {
                "RuleCategoryId": 1,
                "Verbiage": userAddedComments,
                "Notes": null
            }
        }
        try {
            const parsedBody = await invokeLambda(configData.CONDITION_ACTIONS, {
                ...lambdaConfig,
                SecurityToken: localStorage.getItem('SecurityToken'),
                ConditionJSON: conditionjsonForAdd,
            });
            if (parsedBody.Status) {
                toast.success("Condition Added Sucessfully", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            } else {
                toast.error("Condition Not Added Sucessfully", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
            closeAssetsCondition();
            setUserAddedComments('');
            getGeneralInfoDetailsForLoan();
        } catch (err) {
            // Handle error if needed
        }
    }


    const handleToggleFilter = () => {
        setIsCheckedFilter(prevChecked => !prevChecked);
        // Call your method here
        // console.log('Checkbox is now:', !isChecked);
        if (!isCheckedFilter) {
            const shouldNegateReviewed = GlassBoxDatas?.ConditionDetails[0]?.Verbiage.some(item => item.RRSV === "Reviewed");

            // Create a new object with filtered Verbiage
            const result = {
                ...GlassBoxDatas?.ConditionDetails[0],
                Verbiage: shouldNegateReviewed
                    ? GlassBoxDatas?.ConditionDetails[0]?.Verbiage?.filter(item => item.RRSV !== "Reviewed")
                    : GlassBoxDatas?.ConditionDetails[0]?.Verbiage
            };
            console.log(result)
            setAssetsGridData(result);
        }
        else {
            setAssetsGridData(GlassBoxDatas?.ConditionDetails[0]);
        }

    };

    const hasRightsToAddCondition = () => {
        if (rolesAndRights !== null) {
            let rightID = rolesAndRights.AllRights.find(el => el.RightType.trim() == "ADD_CONDITION")?.RightId;
            if (userRights.some(el => el.RightId == rightID)) {
                return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;
            }
        }
    }

    return (<>
        <div class="d-flex mb-2">
            <div class="p-2 px-0 flex-fill">
                <h6 class="mb-0">Asset Conditions</h6>
            </div>
            {GlassBoxDatas?.ConditionDetails[0]?.Verbiage !== null && <div class="m-auto">
                <div class="d-flex justify-content-end align-items-center">
                    <div class="me-2"><i class="ri-filter-line"></i></div>
                    <div class="me-1"><label class="form-check-label" for="flexSwitchCheckChecked">Filter</label></div>
                    <div class="me-2">
                        <div class="form-check form-switch">
                            <input className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckDefault"
                                checked={isCheckedFilter}
                                onChange={handleToggleFilter} />
                        </div>
                    </div>
                    <div class="">
                        {hasRightsToAddCondition() && (<button type="button" disabled={LoanStatus === "Completed"} class="btn btn-outline-primary btn-sm me-1" onClick={goToAssetsCondition}>Add Condition</button>)}
                          {/* <button type="button" class="btn btn-outline-primary btn-sm me-1" onClick={goToAssetsSummary}>View Assets Summary</button>*/}
                        <DgGeneralInfoSave getGeneralInfoDetailsForLoan={getGeneralInfoDetailsForLoan} conditionjson={conditionjson}
                            setConditionJson={setConditionJson} LoanStatus={LoanStatus} />
                        {/* <button type="button" class="btn btn-outline-success btn-sm me-1" onClick={saveAddOrWaivedCondition}>Save</button>
                        <button type="button" class="btn btn-outline-primary btn-sm me-1" onClick={gotoDashboard}>Cancel</button> */}
                    </div>
                </div>
            </div>}
        </div>
        <div className='row'>
            <div className='col-sm-12 grid-columns'>
                {GlassBoxDatas && <DgGeneralInfoTable assetsData={assetsGridData} glassboxjson={GlassBoxDatas} conditionjson={conditionjson}
                    setConditionJson={setConditionJson} getGeneralInfoDetailsForLoan={getGeneralInfoDetailsForLoan} LoanStatus={LoanStatus} />}
            </div>
        </div>
        <DgGeneralInfoPublishCompleteLoan glassboxjson={GlassBoxDatas} LoanStatus={LoanStatus} />
        {/* {GlassBoxDatas?.ConditionDetails[0]?.Verbiage !== null && <div class="d-flex justify-content-end  mb-2">

            {LoanStatus === "Published" ? <button type="button" class="btn btn-primary btn-sm me-5">Complete Loan</button> : <button type="button" class="btn btn-primary btn-sm me-5" onClick={publishLoan}>Publish</button>}
        </div>} */}
        <Offcanvas show={showAssetsSummary} onHide={closeAssetsSummary} placement="end" className="offcanvas offcanvas-end oc-assets-summary">
            <Offcanvas.Header closeButton className='border-bottom'>
                <Offcanvas.Title className='mb-0'>Assets Summary</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div class="d-flex justify-content-between mb-3">
                    <div class="flex-fill pe-2">
                        <h6>Required Assets</h6>
                        <table class="table table-sm table-bordered">
                            <tbody>
                                {assetsSummaryJson.TopCards.slice(0, 3).map((assetssummarydata, index) => (
                                    <tr key={index}>
                                        <td>{assetssummarydata.FieldName}
                                        </td>
                                        <td>
                                            {assetssummarydata.FieldValue}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div class="flex-fill ps-2">
                        <h6>Funds Available</h6>
                        <table class="table table-sm table-bordered">
                            <tbody>
                                {assetsSummaryJson.TopCards.slice(-2).map((assetssummarydata, index) => (
                                    <tr key={index}>
                                        <td>
                                            <b>{assetssummarydata.FieldName}</b>
                                        </td>
                                        <td>
                                            {assetssummarydata.FieldValue}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="d-flex flex-column">
                    <div className='card border'>
                        <div className='card-body'>
                            <h6>Deposits Accounts</h6>
                            <p>{assetsSummaryJson.DepositAccountInfo}</p>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column">
                    <h6 c>Other Assets </h6>
                    <table class="table table-sm table-bordered">
                        <thead>
                            <tr>
                                <th>Type</th>
                                <th>Institution</th>
                                <th>Amount</th>
                                <th>Liquidation Req
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {assetsSummaryJson.OtherAccountsInfo.map(otheraccountsdata => (
                                <tr>
                                    <td>{otheraccountsdata.Type}	</td>
                                    <td>{otheraccountsdata.Institution}	</td>
                                    <td>{otheraccountsdata.Amount}	</td>
                                    <td>{otheraccountsdata.LiquidationRequired}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
        <Modal show={showAssetsCondition} onHide={closeAssetsCondition}>
            <Modal.Header closeButton>
                <Modal.Title className='modal-title mb-0'>Add a Condition</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <textarea class="form-control form-control-sm" id="exampleFormControlTextarea1" rows="3" onChange={(e) => setUserAddedComments(e.target.value)}></textarea>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={closeAssetsCondition}>
                    Close
                </Button>
                <button type="button" className='btn btn-outline-primary btn-sm' onClick={closeAssetsCondition}>
                    Cancel
                </button>
                <button type="button" className='btn btn-primary btn-sm' onClick={addAssestsCondition}>
                    Save Changes
                </button>
            </Modal.Footer>
        </Modal>
    </>)
}
export default GeneralInformationAssetsTab